<template>
    <div class='menu-panel'>
    <a-menu 
        :theme="theme" 
        :mode="mode" 
        :openKeys.sync="openKeys" 
        :selectedKeys="selectedKeys"
        @openChange="onOpenChange"
        @select="onSelect" >
        <template v-for="(menu, rIndex) in menuData">
            <a-menu-item v-if="!menu.children" :key="getMenuKey(menu.path, 0, rIndex)" :title="menu.name">
                <router-link :to="convertPath(menu.path)">
                    <div class='menu-item-content'>
                        <a-icon v-if='menu.icon && !isIconFont(menu.icon)' :type="menu.icon"/>
                        <span v-else-if="menu.icon && isIconFont(menu.icon)" :class="['iconfont', menu.icon]"/>
                        <span :class='[{contentFix:isIconFont(menu.icon)},{hidden:collapsed}]'>{{menu.name}}</span>
                    </div>
                </router-link>
            </a-menu-item>
            <a-sub-menu v-else :key="getSubMenuKey(menu.path, 0, rIndex)">
                <span slot="title">
                    <div class='menu-item-content'>
                        <a-icon v-if='menu.icon && !isIconFont(menu.icon)' :type="menu.icon" />
                        <span v-else-if="menu.icon && isIconFont(menu.icon)" :class="['iconfont', menu.icon]"/>
                        <span :class='[{contentFix:isIconFont(menu.icon)},{hidden:collapsed}]'>{{menu.name}}</span>
                    </div>
                </span>
                <!-- <menu-bars :menuData = "menu.children"></menu-bars> -->
                <template v-for="(subMenu, subIndex) in menu.children">
                    <a-menu-item v-if="!subMenu.children" :key="getMenuKey(subMenu.path,rIndex,subIndex)">
                        <router-link :to="convertPath(subMenu.path)">
                            <div class='menu-item-content'>
                                <a-icon v-if='subMenu.icon && !isIconFont(subMenu.icon)' :type="subMenu.icon"/>
                                <span v-else-if="menu.icon && isIconFont(subMenu.icon)" :class="['iconfont', subMenu.icon]"/>
                                <span>{{subMenu.name}}</span>
                            </div>
                        </router-link>
                    </a-menu-item>
                    <a-sub-menu v-else :key="getSubChildMenuKey(subMenu.path, 0, subIndex)">
                        <span slot="title">
                            <div class='menu-item-content'>
                                <a-icon v-if='subMenu.icon && !isIconFont(subMenu.icon)' :type="subMenu.icon" />
                                <span v-else-if="subMenu.icon && isIconFont(subMenu.icon)" :class="['iconfont', subMenu.icon]"/>
                                <span :class='[{contentFix:isIconFont(subMenu.icon)},{hidden:collapsed}]'>{{subMenu.name}}</span>
                            </div>
                        </span>
                        <a-menu-item v-for="(subChildMenu, subChildIndex) in subMenu.children" :key="getMenuKey(subChildMenu.path,rIndex,subChildIndex)">
                            <router-link :to="convertPath(subChildMenu.path)">
                                <div class='menu-item-content'>
                                    <a-icon v-if='subChildMenu.icon && !isIconFont(subChildMenu.icon)' :type="subChildMenu.icon"/>
                                    <span v-else-if="subMenu.icon && isIconFont(subChildMenu.icon)" :class="['iconfont', subChildMenu.icon]"/>
                                    <span>{{subChildMenu.name}}</span>
                                </div>
                            </router-link>
                        </a-menu-item>
                    </a-sub-menu>
                </template>
            </a-sub-menu>
        </template>
    </a-menu>    
    </div>
</template>

<script>
    export default {
        name: "MenuBars",
        props: {
            menuData: {
            type: Array,
            required: true
            },
            theme: {
            type: String,
            required: false,
            default: 'dark'
            },
            mode: {
            type: String,
            required: false,
            default: 'inline'
            },
            collapsed: {
            type: Boolean,
            required: false,
            default: false
            }
        },
        data () {
            return {
                openKeys: [],
                selectedKeys: [],
                cachedOpenKeys: [],
                currPath:'',
            }
        },
        computed:{
            rootSubmenuKeys: (vm) => {
            let keys = []
            vm.menuData.forEach(item => {
                keys.push(item.path)
            })
                return keys
            }
        },
        watch:{
            collapsed (val) {
                if (val) {
                    this.cachedOpenKeys = this.openKeys
                    this.openKeys = []
                } else {
                    this.openKeys = this.cachedOpenKeys
                }
            },
            '$route': function () {
                // console.log(this.menuData)
                this.updateMenu()
            }
        },
        methods: {
            isIconFont(icon){
                if(!icon) return false
                return icon.indexOf('icon-') === 0
            },
            convertPath(path){
                return `${path}`
                // return `${window.location.origin + path}`
            },
            getSubChildMenuKey(path, pIndex, index){
                let key = path ? path : 'subchildmenu_' + pIndex + '_' + index
                return key
            },
            getSubMenuKey(path, pIndex, index){
                let key = path ? path : 'submenu_' + pIndex + '_' + index
                return key
            },
            getMenuKey(path, pIndex, index){
                let key = path ? path : 'item_' + pIndex + '_' + index
                return key
            },
            onSelect (obj) {
                this.selectedKeys = obj.selectedKeys
                this.$emit('select', obj)
            },
            onOpenChange (openKeys) {
                const latestOpenKey = openKeys.find(key => this.openKeys.indexOf(key) === -1)
                if (this.rootSubmenuKeys.indexOf(latestOpenKey) === -1) {
                    this.openKeys = openKeys
                } else {
                    this.openKeys = latestOpenKey ? [latestOpenKey] : []
                }
            },
            updateMenu () {
                let routes = this.$route.matched.concat()
                if (routes.length >= 4 && this.$route.meta.hidden) {
                    routes.pop()
                    this.selectedKeys = [routes[2].path]
                } else {
                    this.selectedKeys = [routes.pop().path]
                }
                let openKeys = []
                if (this.mode === 'inline') {
                    routes.forEach((item) => {
                    openKeys.push(item.path)
                    })
                }
                this.collapsed ? this.cachedOpenKeys = openKeys : this.openKeys = openKeys
            }
        },
        created(){
            this.updateMenu()
        }
    }
</script>

<style scoped>
    .menu-panel{
        width: 100%;
        height: 95%;
        /* overflow: auto */
    }
    .iconfont{
        font-size: 18px;
        padding-right: 4px;
        position: relative;
        left:-2px;
        top:2px;
    }
    .iconfont{
        font-size: 18px;
        margin-right: -8px;
        position: relative;
        left:-8px;
        top:2px;
    }
    svg{
        font-size: 16px;
        margin-right: -2px;
        position: relative;
        left:-8px;
        top:2px;
    }
    .hidden{
        display:none;
    }
    .menu-item-content{
        position: relative;
        width: 60px;
    }
    .menu-item-content > i {
        margin-right:0px
    }
</style>



// WEBPACK FOOTER //
// src/components/menu/MenuBar.vue